import { render, staticRenderFns } from "./responseDetail.vue?vue&type=template&id=a1435058&scoped=true"
import script from "./responseDetail.vue?vue&type=script&lang=js"
export * from "./responseDetail.vue?vue&type=script&lang=js"
import style0 from "./responseDetail.vue?vue&type=style&index=0&id=a1435058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1435058",
  null
  
)

export default component.exports